import { Box, Grid, Typography } from '@mui/material';
import styles from './Others.module.scss';
import { useNavigate, useNavigation } from 'react-router-dom';
import { HcccCard } from '../common/StyledComponents/StyledFields';

const Others = (): JSX.Element => {
   const navigation = useNavigate();

   const handleCardClick = () => {
      navigation('/bhajana');
   }
   const voulnterRegClick = () => {
   navigation('/volunteer')
   };
   const hadnleFaqClick = ()=>{
      navigation('/faqs')
   }
   const handleAbouttemple =()=>{
      navigation('/abouttemple')
   }
   return (
      <>
         {/* <Typography
            sx={{
               fontFamily: 'Lato',
               fontSize: '25px',
               fontStyle: 'normal',
               fontWeight: 700,
               color: '#313131',
               marginTop: '20px',
               marginBottom:"10px"
            }}
         >
            Other
         </Typography> */}
         <Grid className={styles.totalLayout}>
            <HcccCard className={styles.singleLayout} onClick={voulnterRegClick}>
               <img src={"/images/VolunteerRegistratration.svg"} className={styles.image} />
               <Typography className={styles.titleStyles}>Volunteer Registration</Typography>
            </HcccCard>
            <HcccCard className={styles.singleLayout} onClick={handleCardClick}>
               <img src={"/images/Prayer.svg"} className={styles.image} />
               <Typography className={styles.titleStyles}>Sahana Vavathu Prayer</Typography>
            </HcccCard>
            <HcccCard className={styles.singleLayout} onClick={handleAbouttemple}>
               <img src={"/images/AboutTempleSmall.svg"} className={styles.image} />
               <Typography className={styles.titleStyles} >About Temple</Typography>
            </HcccCard>
            <HcccCard className={styles.singleLayout} onClick={hadnleFaqClick}>
               <img src={"/images/FAQ.svg"} className={styles.image} />
               <Typography className={styles.titleStyles}>FAQ</Typography>
            </HcccCard>
         </Grid>
      </>
   );
};

export default Others;
